<template>
  <div>
    <h3 class="stepper-header" ref="stepperHeader">{{ availableSteps[currentStep.index].header }}</h3>
    <div class="stepper-box">
      <div class="top">
        <div v-if="displayNumeral">
          <h2>{{ currentStep.index + 1 }} / {{ availableSteps.length }}</h2>
        </div>
        <div v-else class="steps-wrapper" :style="{'margin-left': `calc(-${((100 / availableSteps.length)/2)}% + .8rem / 2)`}">
          <template  v-for="(step, index) in availableSteps">
            <div :class="['step', isStepActive(index), isStepCompleted(step)]"
                 :key="index"
                 :style="{width: `${100 / availableSteps.length}%`}">
              <div class="circle" />
            </div>
          </template>
        </div>
      </div>
      <div class="content">
        <keep-alive>
          <component :ref="availableSteps[currentStep.index].id"
                     :is="availableSteps[currentStep.index].component"
                     :current-step="currentStep" />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array
    },
    reset: {
      type: Boolean,
      default: false
    },
    displayNumeral: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentStep: {},
      previousStep: {},
      finalStep: false
    };
  },

  computed: {
    availableSteps() {
      return this.steps.filter(step => step.active) || [];
    },
  },

  methods: {
    isStepActive(index) {
      return this.currentStep.index >= index
        ? "activated"
        : "deactivated";
    },

    isStepCompleted(step) {
      return step.completed ? "completed" : "";
    },

    activateStep(index, back = false) {
      if (this.availableSteps[index]) {
        this.previousStep = this.currentStep;
        this.currentStep = {
          id: this.availableSteps[index].id,
          index: index
        };

        if (!back)
          this.$emit("completed-step", this.previousStep);
      }

      this.$emit("active-step", this.currentStep);
    },

    setStep(index) {
      for (let i = 0; i < index; i++) {
        this.availableSteps[i].completed = true;
      }

      this.activateStep(index);
      this.$forceUpdate();
    },

    async next() {
      const result = await this.$refs[this.availableSteps[this.currentStep.index].id].submit();
      const validator = this.$refs[this.availableSteps[this.currentStep.index].id].$v;

      if ((validator && validator.$invalid) || result === false) {
        this.finalStep = false;
        return;
      }

      this.availableSteps[this.currentStep.index].completed = true;

      if (this.availableSteps.length - 1 == this.currentStep.index)
        this.finalStep = true;

      if (this.finalStep)
        this.$emit("stepper-finished", this.currentStep);

      let currentIndex = this.currentStep.index + 1;

      this.activateStep(currentIndex);
      
      this.$nextTick(() => this.scrollToHeader());

      this.$forceUpdate();
    },

    back() {
      this.$emit("clicking-back");

      let currentIndex = this.currentStep.index - 1;

      if (currentIndex >= 0)
        this.activateStep(currentIndex, true);

      this.$nextTick(() => this.scrollToHeader());
    },

    init() {
      this.activateStep(0);
    },

    scrollToHeader() {
      this.$refs.stepperHeader.scrollIntoView({ behavior: 'smooth' });
    }
  },

  watch: {
    reset(val) {
      if(!val) {
        return;
      }

      this.keepAliveData = false;

      this.init();
      this.previousStep = {};

      this.$nextTick(() => {
        this.keepAliveData = this.keepAlive;
        this.$emit('reset', true);
      });

    }
  },

  created() {
    this.init();
  }
};
</script>